<!--
    SEARCH BAR COMPONENT USED TO FIND PATIENTS GIVEN AN INPUT.
    CURRENTLY SIMPLY EMITS ITS INPUT TO PARENT.
    COMPONENT PART OF © AREA 19, OCG WEB APP.
    DEVELOPED IN MONTREAL, QC, CANADA.
    JULY 2023.
  -->

<script setup>
import { ref } from 'vue';

const emit = defineEmits(['searchTermUpdated']);

const searchTerm = ref('');

const handleInput = () => {
  // Emit the search term to the parent component
  emit('searchTermUpdated', searchTerm.value);
};

const handleKeydown = (event) => {
  if (event.key === 'Escape') {
    event.preventDefault();
    searchTerm.value = '';
  }
  else if (event.key === 'Backspace') {
    event.preventDefault();
    searchTerm.value = searchTerm.value.slice(0, -1);
  }
  handleInput();
};
</script>

<template>
  <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
  <input
    v-model="searchTerm"
    class="general-input w-96"
    type="text"
    placeholder="Search Study..."
    @input="handleInput"
    @keydown="handleKeydown"
  >
</template>
